export default class Format {
    private  sueil : number = 1024;
    public unite : string;
    
    constructor() {
        this.unite = 'Ko'
        
    }
    

    public Ko(taille: number): number{
        this.unite = "Ko";
        return taille/this.sueil;
    }

    public Mo(taille: number): number{
        this.unite = "Mo";
        return taille/(Math.pow(this.sueil, 2));
    }

    public Go(taille: number): number{
        this.unite = "Go";
        return taille/(Math.pow(this.sueil, 3));
    }
    public To(taille: number): number{
        this.unite = "To";
        return taille/(Math.pow(this.sueil, 4));
    }

    public Auto(taille: number): string{
        const toKo = this.Ko(taille);
        if(toKo >= 0  && toKo < this.sueil) return toKo+" "+this.unite;
        else if(toKo >= this.sueil  && toKo < Math.pow(this.sueil, 2)) return this.Mo(taille)+" "+this.unite;
        else if(toKo >= Math.pow(this.sueil, 2)  && toKo < Math.pow(this.sueil, 3)) return this.Go(taille)+" "+this.unite;
        else return this.To(taille)+" "+this.unite;
    }

}